export default __webpack_public_path__ + "static/media/doctorImg.67794899.png";